import { render, staticRenderFns } from "./clickplay.vue?vue&type=template&id=55ccd70b&scoped=true&"
import script from "./clickplay.vue?vue&type=script&lang=js&"
export * from "./clickplay.vue?vue&type=script&lang=js&"
import style0 from "./clickplay.vue?vue&type=style&index=0&id=55ccd70b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ccd70b",
  null
  
)

export default component.exports